// extracted by css-extract-rspack-plugin
export default {"triggerValue":"trigger-value--e128EzGLiNYWG3Qt"};